export const DISPLAY_TABS = {
    'TOP_HIGHER': 'TopHigh',
    'TOP_LOWER': 'TopLower'
}